module.exports = __webpack_public_path__ + "img/1541054503.6de18a5e.jpg";